import { ContractsReport } from '@thought-river/negotiations-common/dist/api/contractContent';

/*
    Calculate how many contracts have a high_level_contract_status = processing
*/
export const getReprocessingContractsCount = (reportData: ContractsReport) =>
    reportData.rows.filter(
        (row) => row.high_level_contract_status === 'processing'
    ).length;
